/* Navigation */

document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.getElementById('hamburger');
    const menu = document.getElementById('navigation-menu');

    if (hamburger && menu) {
        hamburger.addEventListener('click', () => {
            menu.classList.toggle('is-open');
            console.log('Menu toggled, is-open:', menu.classList.contains('is-open'));
        });
    }
});

